export default __webpack_public_path__ + "static/media/KaraKorum.8f759d62.jpg";